import React from 'react';
import {Draggable, Droppable} from "react-beautiful-dnd";
import {useStores} from "../stores/Context";
import {GEN_DROP_ZONES} from "../utils/DragAndDrop";

const SidebarNiveaux = ({handleClose}) => {
    const {niveauxIndicateurStore, createWidgetStore} = useStores();

    const handleBackCreateWidgetHome = () => {
        createWidgetStore.resetCreateWidget();
        createWidgetStore.closePanelNiveaux();
        niveauxIndicateurStore.cleanup();
    }

    const handleClosing = () => {
        handleClose(true);
    }

    // function to return the svg icon form the type of the object
    const getIconWidget = (widget) => {
        switch (widget) {
            case 'ObjetUrl':
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2}
                         stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round"
                              d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"/>
                    </svg>
                );
            case 'ObjetTexte':
                return (
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M4.85742 1C6.57171 1 10.0003 1.6132 10.0003 4.06598C10.0003 7.13197 10.0003 12.8574 10.0003 15.5401C10.0003 19.3726 6.14314 18.9894 4.85742 18.9894"
                            stroke="black" strokeWidth="2"/>
                        <path
                            d="M15.1426 19C13.4283 19 9.99972 18.3845 9.99972 15.9223C9.99972 12.8446 9.99974 7.16604 9.99974 4.47307C9.99974 0.625975 13.8569 1.01069 15.1426 1.01069"
                            stroke="black" strokeWidth="2"/>
                    </svg>

                );
            case 'ObjetTableau':
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <rect x="1" y="1" width="16" height="16" stroke="#002335" strokeWidth="2"/>
                        <line x1="0.900391" y1="3" x2="17.1004" y2="3" stroke="#002335" strokeWidth="3"/>
                        <line x1="0.900391" y1="8" x2="17.1004" y2="8" stroke="#002335" strokeWidth="2"/>
                        <line x1="0.900391" y1="12.5" x2="17.1004" y2="12.5" stroke="#002335" strokeWidth="2"/>
                        <line x1="8.2002" y1="0.449219" x2="8.2002" y2="17.5492" stroke="#002335" strokeWidth="2"/>
                    </svg>
                );
            case 'ObjetCalendrier':
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <rect x="1.66699" y="2.5" width="16.6667" height="15.8333" stroke="#002335" strokeWidth="2"/>
                        <path d="M5.83301 0.833984V2.50065" stroke="#002335" strokeWidth="2"/>
                        <path d="M14.167 0.833984V2.50065" stroke="#002335" strokeWidth="2"/>
                        <path d="M1.66699 6.66602H18.3337" stroke="#002335" strokeWidth="2"/>
                        <path d="M5.41699 10.834H6.25033" stroke="#002335" strokeWidth="2"/>
                        <path d="M9.58301 10.834H10.4163" stroke="#002335" strokeWidth="2"/>
                        <path d="M13.75 10.834H14.5833" stroke="#002335" strokeWidth="2"/>
                        <path d="M5.41699 14.166H6.25033" stroke="#002335" strokeWidth="2"/>
                        <path d="M9.58301 14.166H10.4163" stroke="#002335" strokeWidth="2"/>
                        <path d="M13.75 14.166H14.5833" stroke="#002335" strokeWidth="2"/>
                    </svg>
                );
            default:
                return (
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 40 38" fill="none">
                        <path d="M25.7177 7.81629V1.9082H2V25.5405H8.77649" stroke="#70787B" strokeWidth="3"
                              strokeDasharray="3 3"/>
                        <path d="M21.8601 32.8101H10.0439V9.17773H33.6763V20.9939" stroke="#70787B"
                              strokeWidth="3"/>
                        <path d="M29.2267 36.0919L21.9158 20.008L37.9998 27.3189L31.6637 29.7558L29.2267 36.0919Z"
                              stroke="#70787B" strokeWidth="2.5" strokeLinejoin="round"/>
                    </svg>
                );
        }
    }

    return (
        <div id="sidebar_objets" className={" "}>
            {/*<div className="btnAction btnRetourCreateWidget" onClick={handleBackCreateWidgetHome} onTouchEnd={handleBackCreateWidgetHome}>
                <div>Retour</div>
            </div>*/}
            <p className={'title_section'}>
                Ajouter un objet élémentaire
                <span className={'text-2xl font-bold float-right cursor-pointer'}
                      onClick={() => handleClosing()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M5 5L15.6452 15.6452" stroke="#002335" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                            <path d="M5 15.6445L15.6452 4.99937" stroke="#002335" strokeWidth="2" strokeLinecap="round"
                                  strokeLinejoin="round"/>
                        </svg>
                    </span>
            </p>
            <hr/>
            <div className={'grid grid-cols-4 title_section subtitle mb-4'}>
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="32" viewBox="0 0 40 38" fill="none">
                        <path d="M25.7177 7.81629V1.9082H2V25.5405H8.77649" stroke="#70787B" strokeWidth="3"
                              strokeDasharray="3 3"/>
                        <path d="M21.8601 32.8101H10.0439V9.17773H33.6763V20.9939" stroke="#70787B"
                              strokeWidth="3"/>
                        <path d="M29.2267 36.0919L21.9158 20.008L37.9998 27.3189L31.6637 29.7558L29.2267 36.0919Z"
                              stroke="#70787B" strokeWidth="2.5" strokeLinejoin="round"/>
                    </svg>
                </div>
                <div className={"col-span-3"}>
                    Faites glisser vos objets élémentaires sur le tableau de bord à droite.
                </div>
            </div>
            <Droppable droppableId="sideBarNiveaux" isDropDisabled={true}>
                {(provided, snapshot) => (
                    <div
                        className={"listeObjects"}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        isDraggingOver={snapshot.isDraggingOver}
                    >
                        {
                            niveauxIndicateurStore.elementaryWidgetsAvailable.map((widget, index) =>
                                <Draggable key={widget.idWidget} draggableId={widget.idWidget} index={index}>
                                    {(provided, snapshot) => (
                                        <>
                                            <div
                                                className={`droppable-element objectDroppable objectTexte widgetDroppable ${widget.typeWidget}`}
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                isDragging={snapshot.isDragging}
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    transform: snapshot.isDragging
                                                        ? provided.draggableProps.style?.transform
                                                        : 'translate(0px, 0px)',
                                                }}
                                            >
                                                {provided.placeholder}
                                                <div className="iconWidget">
                                                    {getIconWidget(widget.typeWidget)}
                                                </div>
                                                <div className="nomObject">{widget.nomWidget}</div>
                                            </div>

                                            {snapshot.isDragging && (
                                                <div
                                                    className={`droppable-element objectDroppable objectTexte widgetDroppable ${widget.typeWidget}`}
                                                    style={{opacity: .5}}>
                                                    <div className="iconWidget">
                                                        {getIconWidget(widget.typeWidget)}
                                                    </div>
                                                    <div className={"nomObject"}>
                                                        {widget.nomWidget}
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Draggable>
                            )
                        }
                    </div>
                )}
            </Droppable>
        </div>
    );
};

export default SidebarNiveaux;
